
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    export class OrderStatusAuthorizeDialog extends Serenity.PropertyDialog<any, any>
    {

        public form = new OrderStatusAuthorizeForm(this.idPrefix);
        public entity: any;
        public voucherno: string;
        public vouchertypeid: number;
        public inst;
        public remark;
        public checksuccess: boolean;
        public status: number;
        public _checklist: ECommerce.OrderManagementCheckListRow[];
        constructor() {
            super();

            this.form = new OrderStatusAuthorizeForm(this.idPrefix);
            q.hideEditorLabel(this.form.CheckList);
            q.hideEditorToolbar(this.form.CheckList);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
        }

        protected getDialogTitle(): string {
            return "Approve";
        }

        protected onDialogOpen() {
            super.onDialogOpen();
            this.form.Pieces.value = this.entity.Pieces;
            this.form.Weight.value = this.entity.Weight;
            this.form.VoucherNo.value = this.entity.VoucherNo;
            this.form.ECommOrderNo.value = this.entity.ECommOrderNo;
            this.form.Remarks.value = this.entity.Remark;
            this.form.CheckList.setData(this.entity.CheckList);
        }


        protected getDialogButtons() { 
            return [
                {
                    text: 'Ok',
                    click: () => {
                        if (!this.validateBeforeSave())
                            return;
                        //var checklist = this.form.CheckList.getItems();
                        //this.status = 4;
                        //for (var i = 0; i < checklist.length; i++) {
                        //    if (checklist[i].CheckListValue == false)
                        //        this.status = 3;
                        //}
                        //this._checklist = checklist;
                        this.checksuccess = true;
                        this.dialogClose();
                        return true;
                    },
                }, 
                {
                    text: 'Cancel',
                    click: () => {
                        this.checksuccess = false;
                        this.dialogClose();

                    }
                }
            ];
        }
    }
}